module.exports = __webpack_public_path__ + "static/media/database.39f2d19b.svg";